import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {DataGridSort} from './data-grid-sort/data-grid-sort';

@Injectable()
export class DataGridService {
    public query$: ReplaySubject<string>;
    public sort$: ReplaySubject<DataGridSort>;

    constructor() {
        this.query$ = new ReplaySubject<string>(1);
        this.sort$ = new ReplaySubject<DataGridSort>(1);
    }
}
